import styled from 'styled-components';

export const OffcanvasContainer = styled.div`
  display: grid;
  grid-template-rows: 50px 1fr auto;
  height: 100vh;
  width: 100%;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.azulgov};
  color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 16px;
  margin-bottom: 0;
  line-height: 1.15;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const Body = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  background-color: var(--white);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover);
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--card-borda);
  background: var(--light);
  min-height: 60px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 10px 12px;
    flex-direction: column;
    gap: 8px;
  }
`;

export const FooterContentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const FooterContentRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    margin-left: 0;
  }
`;
